import React from "react";
import { bool, func, string, node } from "prop-types";
import cx from "classnames";

import Icon from "../../components/Icon/Icon.jsx";

const propTypes = {
  darkTheme: bool,
  smallButton: bool,
  isPlaying: bool.isRequired,
  className: string,
  label: string,
  onClick: func.isRequired,
  children: node,
};

const VideoButton = (props) => {
  const {
    isPlaying,
    onClick,
    label = "play video",
    darkTheme,
    smallButton,
    children,
    className,
    ...rest // Capture additional props
  } = props;

  return (
    <button
      className={cx("video-button", className, {
        "video-button--playing": isPlaying,
        "video-button--dark theme-dark": darkTheme,
        "video-button--small": smallButton,
      })}
      onClick={onClick}
      type="button"
      aria-label={label}
      aria-pressed={isPlaying}
      {...rest} // Spread additional props onto the button
    >
      {children}
      <span className="video-button__play-icon">
        <Icon iconName="play-icon" />
      </span>
    </button>
  );
};
VideoButton.propTypes = propTypes;
export default VideoButton;
